import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Stack,
} from "@mui/material";
import { StyledButton } from "../../../shared/components/buttons/custom-button";
import { CustomRadio, CustomTextField } from "../../../shared/components/inputfields/form-elements";
import { NavLink, useParams } from "react-router-dom";
import { useApi } from "../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../shared/components/loaders/page-loader";
import { ETCAppConfig } from "../../../shared/app-configs/etc-app-configs";
import { TCAppConfig } from "../../../shared/app-configs/tc-app-configs";

const DeclarationByCertificateBody: React.FC = () => {
  const [outsourced, setOutsourced] = React.useState('');
  const [additionalText, setAdditionalText] = React.useState<string>('');
  const { etcId } = useParams<string>()
  const { loading, executeGet } = useApi();
   const [getTcStandardDetails, setTcStandardDetails] = useState<any>([]);
  
  const fetchDetails = async () => {
    const result = await executeGet(ETCAppConfig.GET_DECLARATION_SUBMIT_DETAILS, { etcId: etcId });
    setOutsourced(result?.data.tcOutsourcedToSubcontractor)
    setAdditionalText(result?.data.tcSellerProductDeclarations)

  }
    const fetchStandardDetails = async () => {
      const response: any = await executeGet(ETCAppConfig.GET_ETC_BASE_DETAILS, { etcId: etcId });
      if (response?.data) {
        setTcStandardDetails(response?.data?.tcStandard)
      }
    }
  useEffect(() => {
      fetchDetails();
      fetchStandardDetails();
  }, [])
  const handleSubmit = async () => {}

  return (
    <Box p={4}>

      {loading ? <LoaderComponent /> :
        <>
          {/* Declaration by Certification Body */}
          <Typography variant="body1" gutterBottom align="left" fontWeight="600">
            Declaration by Certification Body:
          </Typography>
          <Typography variant="body1" gutterBottom>
            This is to certify that, based on the relevant documentation provided by the seller named in screen "Buyer & Seller Details":
          </Typography>
          <Typography
            variant="body1"
            component="div"
            sx={{
              mt: 1,
              pl: 3,
              "& ul": {
                listStyleType: "disc",
                paddingLeft: 2,
                margin: 0,
              },
              "& li": {
                marginBottom: 1.5,
                fontSize: "1rem",
                lineHeight: 1.5,
                color: "text.primary",
              },
            }}
          >
            <ul>
              <li>
                The raw material(s) for the products as further detailed/referred to
                screen "eTC Products Details", "Certified Raw Material & Standard Details"
                and "Gross Shipping Weight", "Net Shipping Weight" and "Certified Weight"
                has/have been produced in accordance with the  {getTcStandardDetails.map((item:any) => `(${item})`).join(", ")}.
              </li>
              <li>
                The products in "eTC Products Details" have been processed in accordance
                with the  {getTcStandardDetails.map((item:any) => `(${item})`).join(", ")}. Conformity with the standard is audited and
                monitored systematically under the responsibility of the certification body.
              </li>
            </ul>
          </Typography>

          {/* Declarations by Seller of Certified Products */}
          <Typography variant="body1" gutterBottom align="left" fontWeight="600">
            Declarations by Seller of Certified Products:
          </Typography>
          <Stack gap={2}>

            <Typography variant="body1" gutterBottom>
              The certified product(s) covered in this certificate have been outsourced to a subcontractor:
            </Typography>
            <Stack direction={'row'} alignItems={'center'}>

              <Typography variant="body1" gutterBottom sx={{ mr: 2 }}>

                eTC Outsourced to Subcontractor: {outsourced==='Yes' ? 'Yes' : 'No'}
              </Typography>
              {/* <CustomRadio
                name="outSource"
                // label="TC Outsourced to Subcontractor"
                value={outsourced}
                onChange={(event) => setOutsourced(event.target.value)}
                disabled={true}
                readOnly= {true}
                required={false}
                options={[
                  { label: "Yes", value: "Y" },
                  { label: "No", value: "N" },
                ]}

              /> */}
            </Stack>
          </Stack>

          <CustomTextField
            label="Additional declaration text"
            variant="outlined"
            fullWidth
            multiline
            rows={3}
            readOnly= {true}
            placeholder="Enter Declaration Text"
            value={additionalText}
            onChange={(event) => setAdditionalText(event.target.value)}
            sx={{ mb: 4 }}
          />

          {/* Action StyledButtons */}
          <Box display="flex" justifyContent="center" gap={2}>
            {/* <StyledButton variant="contained" onClick={handleSubmit} color="primary">Submit</StyledButton> */}
            {/* <StyledButton variant="contained" color="primary">Generate TC Word</StyledButton>
            <StyledButton variant="contained" color="primary">Generate JSON</StyledButton> */}
            <NavLink to="/tc-dashboard">
              <StyledButton variant="contained">
                Close
              </StyledButton>
            </NavLink>
          </Box>
        </>
      }
    </Box>
  );
};

export default DeclarationByCertificateBody;